// helpers
var listen = function(element,event,calbak){
    var elem = element.length > 0 ? element : [element];
    for(var i = 0; i < elem.length; i++){
        elem[i].addEventListener(event,calbak);
    }
};
var v$ = function(string,parent,importance){
    var parent = parent ? parent : document,
            elements = parent.querySelectorAll(string),
             importance = importance || importance === 0  ? importance : 1;
    if(!elements.length > 0){
        if(importance > 1){
            throw new Error('No items with a selector: ' + string);
        }else if(importance > 0){
            console.warn('No items with a selector: ' + string);
        }
        return false;
    } else{
        return elements;
    }
};

const compose = (...fnc) => x => fnc.reduceRight((a,b) => b(a),x);

const defaultSettings = {
  activeClass: 'active',
  startBlock:'span',
  generateInp:true,
  inpId:'',
  defaultRate:0
}
//Elements
const vRate = (target, obj = defaultSettings) => {
  const concatObj = {
    ...defaultSettings,
    ...obj
  };
  let container = v$(`#${target}`)[0],
      stars = v$(concatObj.startBlock,container),
      input = concatObj.generateInp ? document.createElement('input') : document.querySelector(`#${concatObj.inpId}`);
  //Push input to DOM

  if(concatObj.generateInp){
    input.type = 'hidden';
    input.name = target;
    input.id = target;
    container.appendChild(input);
  }

  //data
  let selectedRate = concatObj.defaultRate;

  //Functions

  const getID = (target) => {
  let id = null;
  stars.forEach( (item,index) => {
      if(item === target){
        id =  index;
      }
  })
  return id;
  }

  const hoverStars = id => {
      stars.forEach((item,index) => {
        item.classList.remove(concatObj.activeClass);
        if(index <= id){
          item.classList.add(concatObj.activeClass);
        }
      })
  }
  const unHover = () => stars.forEach( (item,id) => {
    if(id <= selectedRate && selectedRate !== null){
      item.classList.add(concatObj.activeClass);
    }else{
      item.classList.remove(concatObj.activeClass);
    }
  });
  const remeberRate = (id) => {
    selectedRate = id
    return id;
  };
  const setHiddenInpValue = (id) => {
    input.value = id + 1;
  }

  const setRate  = compose(
    setHiddenInpValue,
    remeberRate,
    getID
  )

  const handleHover = compose(
    hoverStars,
    getID
  )


  //Listeners
  listen(stars,'mouseenter', e => {
    handleHover(e.target);
  })
  listen(stars,'click',e => {
    setRate(e.target);
  })
  listen(stars,'mouseleave', e => unHover());

}

export default vRate;
